import { render, staticRenderFns } from "./plane.vue?vue&type=template&id=b896e886&scoped=true&"
import script from "./plane.vue?vue&type=script&lang=js&"
export * from "./plane.vue?vue&type=script&lang=js&"
import style0 from "./plane.vue?vue&type=style&index=0&id=b896e886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b896e886",
  null
  
)

export default component.exports